import type { JSONContent } from '@tiptap/core'

export const isJsonContentEmptyParagraphOnly = (json: JSONContent): boolean => {
  if (json.content?.length === 1 && json.content[0].type === 'paragraph') {
    return !json.content[0].content || json.content[0].content.length === 0
  }

  return false
}
